import {useEffect,useId,type CSSProperties} from "react";
import {X} from "lucide-react";
import {TimelineActor} from "./timeline-actor";

export type TimelineDialogEvent={
  id:string|number;
  title:string;
  detail:string;
  author?:string|null;
  at?:string|null;
  color?:string;
};

export function TimelineDialog({title,description,events,onClose,loading=false,emptyMessage="Nenhuma movimentação registrada."}:{title:string;description:string;events:TimelineDialogEvent[];onClose:()=>void;loading?:boolean;emptyMessage?:string}){
  const titleId=useId();
  useEffect(()=>{const close=(event:KeyboardEvent)=>{if(event.key==="Escape")onClose()};window.addEventListener("keydown",close);return()=>window.removeEventListener("keydown",close)},[onClose]);
  return <div className="maintenance-timeline-backdrop" role="presentation" onMouseDown={event=>{if(event.target===event.currentTarget)onClose()}}>
    <section className="maintenance-timeline-dialog" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <header><div><span className="eyebrow">Linha do tempo</span><h3 id={titleId}>{title}</h3><p>{description}</p></div><button type="button" aria-label="Fechar linha do tempo" onClick={onClose}><X/></button></header>
      <div className="maintenance-timeline-content">{loading?<p className="timeline-empty">Carregando linha do tempo…</p>:events.length?events.map(event=><article className="maintenance-timeline-event" key={event.id} style={{"--timeline-event-color":event.color||"var(--primary)"} as CSSProperties}><i/><div><div><strong>{event.title}</strong><time>{event.at?new Date(event.at).toLocaleString("pt-BR"):"—"}</time></div><p>{event.detail}</p><TimelineActor name={event.author}/></div></article>):<p className="timeline-empty">{emptyMessage}</p>}</div>
    </section>
  </div>;
}
